import Button from 'react-bootstrap/Button';

function DeleteButton({ text, onClick, className, disabled = false }) {
  return (
    <Button
      variant='outline-primary'
      className={`d-flex align-items-center justify-content-center ${className}`}
      onClick={() => onClick()}
      disabled={disabled}
    >
      <span className='material-symbols-outlined me-2'>delete</span>
      {text ?? 'Ta bort'}
    </Button>
  );
}

export default DeleteButton;
